import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { generateMenu, validatePermission } from "./Function";
import { setIsCheckOpenModal } from "app/Reducers/examSlice";
export const Sidebar = () => {
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  const [lsMenu, setLsMenu] = useState([]);
  const [isActive, setIsActive] = useState(0);
  const [isActive2, setIsActive2] = useState(0);
  const [isActive3, setIsActive3] = useState(0);
  const [lsPermission, setLsPermission] = useState([]);
  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    const arrTeam = userInfo.team_permissions.map((item, index) => {
      return item.phanquyen__ten_pq;
    });
    setLsPermission([...userInfo.user_permissions, ...new Set(arrTeam)]);
    setLsMenu(
      generateMenu([...userInfo.user_permissions, ...new Set(arrTeam)])
    );
  }, [userInfo]);
  useEffect(() => {
    if (location.pathname && lsMenu) {
      dispatch(setIsCheckOpenModal(false));
      let arr = [];
      for (const i of lsMenu) {
        for (const j of i.data) {
          if (!j.children) {
            arr.push(j.url);
            if (location.pathname.toString() === j.url.toString()) {
              setIsActive2(j.key);
              setIsActive(i.key);
              setIsActive3(0);
              break;
            }
          } else {
            for (const k of j.children) {
              arr.push(k.url);
              if (location.pathname.toString() === k.url.toString()) {
                setIsActive3(k.key);
                setIsActive2(j.key);
                setIsActive(i.key);
                break;
              }
            }
          }
        }
      }
    }
  }, [lsMenu, location]);
  return (
    <>
      <div className="topnav">
        <div className="container-fluid">
          <nav className="navbar navbar-light navbar-expand-lg topnav-menu">
            <div className="collapse navbar-collapse" id="topnav-menu-content">
              <ul className="navbar-nav">
                {lsMenu.map(
                  (item, index) =>
                    item.isShow && (
                      <li className="nav-item dropdown" key={index}>
                        <a
                          href="#"
                          id="topnav-uielement"
                          role="button"
                          className={"nav-link dropdown-toggle arrow-none"}
                        >
                          <i
                            className={`${
                              isActive === item.key ? "activeMenu" : ""
                            } ${item.icon}`}
                          ></i>
                          <span
                            key="t-ui-elements"
                            className={`${
                              isActive === item.key ? "activeMenu" : ""
                            }`}
                          >
                            {item.name}
                          </span>
                          <div className="arrow-down"></div>
                        </a>

                        <div
                          className="dropdown-menu styleDropMenu"
                          aria-labelledby="topnav-uielement"
                        >
                          {item.data.map(
                            (itemData, indexData) =>
                              userInfo &&
                              lsPermission &&
                              validatePermission(
                                lsPermission,
                                itemData.requiredPermission
                              ) && (
                                <div
                                  className={`${
                                    itemData.children ? "dropdown" : ""
                                  }`}
                                  key={indexData}
                                >
                                  {itemData.children ? (
                                    <a
                                      className={`${
                                        isActive2 === itemData.key
                                          ? "activeMenu"
                                          : ""
                                      } dropdown-item`}
                                      key={itemData.key}
                                    >
                                      {itemData.name}
                                      {itemData.children && (
                                        <div className="arrow-down"></div>
                                      )}
                                    </a>
                                  ) : (
                                    <Link
                                      to={itemData.url}
                                      className={`${
                                        isActive2 === itemData.key
                                          ? "activeMenu"
                                          : ""
                                      } dropdown-item`}
                                    >
                                      {itemData.name}
                                    </Link>
                                  )}
                                  {itemData.children && (
                                    <div className="dropdown-menu">
                                      {itemData.children.map(
                                        (itemChild, indexChild) => (
                                          <Link
                                            to={itemChild.url}
                                            className={`${
                                              isActive3 === itemChild.key
                                                ? "activeMenu"
                                                : ""
                                            } dropdown-item`}
                                            key={itemChild.key}
                                          >
                                            {itemChild.name}
                                          </Link>
                                        )
                                      )}
                                    </div>
                                  )}
                                </div>
                              )
                          )}
                        </div>
                      </li>
                    )
                )}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};
